import TopWeather from "~/components/TopWeather";
import provideWeather from "~/utility/provideWeather";
export default provideWeather(TopWeather);
